<template lang="pug">
.container.is-fluid
    .columns
        .column.is-narrow
            p.title.t-1 Users
    .columns
        .column.is-3
</template>

<script>
export default {
  name: "Users"
};
</script>
